const getters = {
 sidebar: state => state.app.sidebar,
 device: state => state.app.device,
 token: state => state.user.token,
 avatar: state => state.user.avatar,
 name: state => state.user.name,
 openid: state => state.user.openid,
 uid: state => state.user.uid,
 role: state => state.user.role,
 systemAdmin: state => state.user.systemAdmin,
 groupUid: state => state.user.groupUid,
 ownerUid: state => state.user.ownerUid,
 permissions: state => state.user.permissions,
 orgUid: state => state.user.orgUid,
 dataScope: state => state.user.dataScope,
 roles: state => state.user.roles,
 permission_routes: state => state.permission.routes,
 theme: state => state.app.theme,
 language: state => state.app.language,
 size: state => state.app.size,
}

export default getters
